/**
 * Returns true if the user's cookie information already matches the url.
 *
 * Ex:
 *    https://www.edmunds.com/used-cars-chicago-il/ returns true if the user's cookie also contains chicago, il
 *    https://www.edmunds.com/used-cars-long-beach-ca/ returns false if the user's cookie contains long beach, wa
 *    https://www.edmunds.com/used-cars-california/ returns true if the user's cookie also contains california.
 *
 * @param urlContext
 * @param locationCookie
 * @param cookieData
 * @returns {boolean}
 */
function userHasSameLocationAsUrl({ urlContextLocation = {}, userLocation = {} }) {
  const { city: urlCity, stateCode: urlStateCode } = urlContextLocation;
  const { city: userCity, stateCode: userStateCode } = userLocation;

  // IF the url has a city in it AND that city is different from the user's currently set city
  // THEN return false because the user does not have the same location as the url.
  if (urlCity) {
    if (userCity?.toLowerCase() !== urlCity.toLowerCase()) {
      return false;
    }
  }

  // IF the url has a state in it AND that state is different from the user's currently set state
  // THEN return false because the user does not have the same location as the url.
  if (urlStateCode) {
    if (userStateCode?.toLowerCase() !== urlStateCode.toLowerCase()) {
      return false;
    }
  }

  // OTHERWISE return true because the url user's currently set location matches what is present in the url
  return true;
}

export const shouldIgnoreUrlContext = ({ urlContextLocation, userLocation, isCrawler }) =>
  !isCrawler && userHasSameLocationAsUrl({ urlContextLocation, userLocation });
